function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#fff",
  y: 85.331,
  width: 512,
  height: 341.337
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#bc002d",
  cx: 250,
  cy: 260,
  r: 130
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/japan.4c2ea2ed.svg";
export { SvgComponent as ReactComponent };